import {
  UPLOAD_ADD,
  UPLOAD_DELETE,
} from './upload-hook-action-types';
import AsyncThunkCreator from '../../../shared-types/AsyncThunkCreator.type';

export const uploadAdd = (uuid: string, files: File[], fileNameUrlMap: Map<string, string>): AsyncThunkCreator => async (
  dispatch, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  getState, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  api, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
): Promise<void> => {
  dispatch({
    type: UPLOAD_ADD,
    uuid,
    files,
    fileNameUrlMap,
  });
};

export const uploadDelete = (uuid: string): AsyncThunkCreator => async (
  dispatch, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  getState, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  api, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
): Promise<void> => {
  dispatch({ type: UPLOAD_DELETE, uuid });
};
